import axios from 'axios'

import type {
  AxiosError,
  AxiosInstance,
  // AxiosRequestConfig, // Change to InternalAxiosRequestConfig
  InternalAxiosRequestConfig,
  AxiosResponse,
} from "axios";

axios.defaults.xsrfCookieName = "CSRF-TOKEN";

axios.defaults.xsrfHeaderName = "X-CSRF-Token";

axios.defaults.withCredentials = true;

const instance = axios.create({
  baseURL: '/api/piada-one/',
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
    'X-Device-Type': 'web',
    'X-App-Version': '1.1.1',
  }
})

const onResponse = (response: AxiosResponse): AxiosResponse => {
  const { method, url } = response.config;
  const { status } = response;
  if (response.headers && response.headers['x-app-require-reload'] && response.headers['x-app-require-reload'] == "true") {
    window.location.reload();
  }

  return response;
};

const onErrorResponse = (error: AxiosError): Promise<AxiosError> => {
  // Could add global error handling here
  if (error.response && error.response.headers && error.response.headers['x-app-require-reload'] && error.response.headers['x-app-require-reload'] == "true") {
    // @ts-ignore
    if (error.response && error.response.data && error.response.data.message) {
      // @ts-ignore
      localStorage.setItem('PiadaOneReload', error.response.data.message);
    } else {
      localStorage.setItem('PiadaOneReload', 'The Online Catering page has been refreshed to get you the most up to date experience.')
    }
    window.location.reload();
  }

  return Promise.reject(error);
}

const setupInterceptors = (instance: AxiosInstance): AxiosInstance => {
  // instance.interceptors.request.use(onRequest, onErrorResponse);
  instance.interceptors.response.use(onResponse, onErrorResponse);

  return instance;
};



export default setupInterceptors(instance);